import React from 'react';
import { MotionConfig } from 'framer-motion';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { MarketplaceProvider } from './contexts/MarketplaceContext';
import { RoleShell } from './components/RoleShell';
import { MatchOverlay } from './components/MatchOverlay';
import { ThemedToaster } from './components/ThemedToaster';
import { Landing } from './pages/Landing';
import { Pricing } from './pages/Pricing';
import { RoleChoice } from './pages/RoleChoice';
import { PerformerOnboarding } from './pages/PerformerOnboarding';
import { OrganiserOnboarding } from './pages/OrganiserOnboarding';
import { Messages } from './pages/Messages';
import { Discover } from './pages/performer/Discover';
import { Gigs } from './pages/performer/Gigs';
import { Profile } from './pages/performer/Profile';
import { Events } from './pages/organiser/Events';
import { CreateEvent } from './pages/organiser/CreateEvent';
import { Review } from './pages/organiser/Review';
import { Account } from './pages/organiser/Account';
interface AppProps {
  previewRole?: 'performer' | 'organiser';
  colorMode?: 'system' | 'light' | 'dark';
  language?: 'en' | 'th';
}
export function App({
  previewRole = 'performer',
  colorMode = 'system',
  language = 'en'
}: AppProps) {
  return <ThemeProvider initialMode={colorMode} data-id="element-0" data-mp="2zm4xcjfp5b1a">
      <LanguageProvider initialLanguage={language} data-id="element-1" data-mp="2zng0qi58cgrv">
        <MarketplaceProvider initialRole={previewRole} data-id="element-2" data-mp="33nq5jrhad155">
          <MotionConfig reducedMotion="user" data-id="element-3" data-mp="38lrq6gud18iq">
            <BrowserRouter data-id="element-4" data-mp="38l053zye2t6p">
              <Routes data-id="element-5" data-mp="38nunzn1r85y0">
                <Route path="/" element={<Landing data-id="element-7" data-mp="3dl4lzr37lpxg" />} data-id="element-6" data-mp="3dkuvm2e95gr8" />
                <Route path="/pricing" element={<Pricing data-id="element-9" data-mp="3dii5v329623m" />} data-id="element-8" data-mp="3dmfolnkx4rmz" />
                <Route path="/start" element={<RoleChoice data-id="element-11" data-mp="nuraocvicv35" />} data-id="element-10" data-mp="nw2e2bl1k0tq" />
                <Route path="/onboarding/performer" element={<PerformerOnboarding data-id="element-13" data-mp="stub1k0jmd4s" />} data-id="element-12" data-mp="nxww9i4xheu4" />
                <Route path="/onboarding/organiser" element={<OrganiserOnboarding data-id="element-15" data-mp="35yngfn0fdzc" />} data-id="element-14" data-mp="swqd9kjfbnz1" />

                <Route path="/p" element={<RoleShell role="performer" data-id="element-17" data-mp="38b2ajxh1886" />} data-id="element-16" data-mp="34nb3rfi0xwm">
                  <Route index element={<Navigate to="discover" replace data-id="element-19" data-mp="3ucjbrrlok7so" />} data-id="element-18" data-mp="3ubriwojgwo63" />
                  <Route path="discover" element={<Discover data-id="element-21" data-mp="d45sc040y5kz" />} data-id="element-20" data-mp="d57dixer88gf" />
                  <Route path="gigs" element={<Gigs data-id="element-23" data-mp="851lhg4kojxt" />} data-id="element-22" data-mp="d2bh5dik1ru3" />
                  <Route path="messages/:matchId?" element={<Messages role="performer" data-id="element-25" data-mp="83qj9kqrzk8t" />} data-id="element-24" data-mp="86w58r43y60b" />
                  <Route path="profile" element={<Profile data-id="element-27" data-mp="3glo2wfb6lqp3" />} data-id="element-26" data-mp="3gmft1am0ew7z" />
                </Route>

                <Route path="/o/events/new" element={<CreateEvent data-id="element-29" data-mp="3bo4kr4bd4trv" />} data-id="element-28" data-mp="3bn2zy84joswy" />
                <Route path="/o" element={<RoleShell role="organiser" data-id="element-31" data-mp="3qbfud0nzi3pc" />} data-id="element-30" data-mp="3qaxrhl6tgr8g">
                  <Route index element={<Navigate to="events" replace data-id="element-33" data-mp="3lkhbpufiwtix" />} data-id="element-32" data-mp="3qdajkr6aghz8" />
                  <Route path="events" element={<Events data-id="element-35" data-mp="3limqef0cazeb" />} data-id="element-34" data-mp="3liwl2fwbxuqc" />
                  <Route path="review/:eventId?" element={<Review data-id="element-37" data-mp="2xtbzrqcpeldw" />} data-id="element-36" data-mp="2xud8ho68yvsg" />
                  <Route path="messages/:matchId?" element={<Messages role="organiser" data-id="element-39" data-mp="2suqyropmnxoe" />} data-id="element-38" data-mp="2svtnpr3e3q1o" />
                  <Route path="account" element={<Account data-id="element-41" data-mp="18d9cm5dahirn" />} data-id="element-40" data-mp="2stzc53e0daa9" />
                </Route>

                <Route path="*" element={<Navigate to="/" replace data-id="element-43" data-mp="1d4hqpepkdsb5" />} data-id="element-42" data-mp="18boigguw01ub" />
              </Routes>
              <MatchOverlay data-id="element-44" data-mp="1d5su3df3ky1q" />
              <ThemedToaster data-id="element-45" data-mp="yflfj8s7nz6b" />
            </BrowserRouter>
          </MotionConfig>
        </MarketplaceProvider>
      </LanguageProvider>
    </ThemeProvider>;
}